import { formatTargetPercentage } from './fundTargetPercentage';

export const formatPercentageDisplay = (
  value: number | null | undefined,
  formatter: (
    value: number | null | undefined,
  ) => string = formatTargetPercentage,
): string => {
  const formatted = formatter(value);
  return formatted === '' ? '' : `${formatted}%`;
};
